import { _api, addCollection } from '@iconify/react';
import heroicons from './heroicons.json';
import { logger } from '@core/utils/logger';

/**
 * Register the bundled icon subset and switch off Iconify's network loader.
 *
 * Without this, `@iconify/react` fetches unknown icons from api.iconify.design at
 * runtime: a centre behind a domain allow-list sees empty squares where the
 * header buttons should be, and every first render flickers until the JSON
 * arrives. The subset is generated by `npm run icons` from the names used in
 * `src/` (see `scripts/build-icons.mjs`); a name that is not in it is a bug, so
 * the loader is replaced by one that logs instead of going online.
 */
export function registerIcons() {
  addCollection(heroicons);
  _api.setFetch((input: RequestInfo | URL) => {
    logger.error(`Icon not bundled, refusing to load it from the network: ${String(input)}`);
    return Promise.reject(new Error('Iconify network loading is disabled'));
  });
}
